<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('masters.pleaseSelectChain')" :loading="loading" @change="$emit('input', $event)">
        <el-option v-for="item in chains" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'chain-selector',
        props: ['value'],
        data() {
            return {
                loading: false,
                chains: []
            }
        },
        created() {
            this.loading = true
            axios.get('/api/customerchains/lookup').then(response => {
                this.loading = false
                this.chains = response.data.map(c => { return { id: c.value, name: c.label } });
            })
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/ChainSelector.vue